// Route to page title mapping for dynamic header titles
export function getPageTitle(pathname: string): string {
  const routeMap: Record<string, string> = {
    '/': 'Home',
    '/video/create': 'Video',
    '/image/create': 'Image',
    '/templates': 'Templates',
    '/template-to-video': 'Template To Video',
    '/my-collection': 'My Collection',
    '/upgrade': 'Upgrade',
    '/credits': 'Credits',
    '/billing': 'Billing',
  };

  // Check exact match first
  if (routeMap[pathname]) {
    return routeMap[pathname];
  }

  // Check for routes that start with a mapped route (e.g., /templates/123)
  for (const [route, title] of Object.entries(routeMap)) {
    if (pathname.startsWith(route + '/') || pathname.startsWith(route + '?')) {
      return title;
    }
  }

  // Default: capitalize first letter after slash and replace hyphens with spaces
  const path = pathname.split('/')[1] || 'Home';
  return path
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
